






import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import commonNewMixins from "@/mixins/commonNewMixins";

@Component({
  name: "ts",
  components: {},
})
export default class ts extends mixins(commonNewMixins) {}
